
<template lang="pug">
  .eui-debug(v-if="debug")
      h4 Logs:
      p(v-for="item in debug") {{ item }}
</template>


<script>
export default {
  name: 'debugLogs',
  props: {
    debug: {
      type: Array
    }
  }
};

</script>

<style lang="scss">

.eui-debug {
  display: block;
}

</style>
